import React, {useRef, useState} from "react";
import {Card, Col, Form, Row, Button} from "react-bootstrap";
import {useFormik} from "formik";
import {Editor} from "@tinymce/tinymce-react";
import Dropzone from "react-dropzone";
import {ToastContainer} from "react-toastify";
import {useDispatch} from "react-redux";
import {Container} from "react-bootstrap";
import * as Yup from "yup";
import {addNewsList as createNewNews} from "../../../slices/pages/news/thunk";
import moment from "moment/moment";
import {useNavigate} from "react-router-dom";

const CreateNews = () => {
    document.title = "Create new news";
    const dispatch = useDispatch<any>();
    const [selectFile, setSelectFile] = useState<any>([]);
    const navigate = useNavigate();
    const editorRef = useRef<{
        getContent: () => string;
        setContent: (content: string) => void;
    } | null>(null);

    const handleEditorInit = (_evt: any, editor: any) => {
        editorRef.current = editor;
    };
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: '',
            shortInfo: '',
            image: '',
            url: '',
            status: "true",
            publishedAt: ''
        },

        validationSchema: Yup.object({
            title: Yup.string().required("Please Enter Your Product Name"),
            shortInfo: Yup.string().required("Please Enter Your Product Name"),
            image: Yup.mixed().required("Please Enter Your Category Image"),
            url: Yup.string().required("Please Enter Your Category Image"),
            publishedAt: Yup.string().required("Please Enter Your Category Image"),
        }),

        onSubmit: async (values) => {
            const formData = new FormData();
            const data = {
                title: values.title,
                shortInfo: values.shortInfo,
                content: editorRef.current ? editorRef.current.getContent() : "",
                url: values.url,
                publishedAt: moment(values.publishedAt).format("DD/MM/YYYY HH:mm:ss"),
                status: values.status,
            }
            formData.append(
                "newsDto",
                new Blob([JSON.stringify(data)], {type: "application/json"}),
                "newsDto.json"
            );
            formData.append("imageFile", values.image);
            dispatch(createNewNews(formData))
                .unwrap()
                .then((data: any) => {
                    if (data.id) {
                        navigate(`/edit-news?id=${data?.id}`)
                    }
                })
                .catch((err: any) => {
                    console.error("Xato:", err);
                });
        }
    });

    const clearContent = () => {
        formik.resetForm({
            values: {
                title: "",
                shortInfo: "",
                image: "",
                url: "",
                status: "true",
                publishedAt: ""
            }
        });
        if (editorRef.current) {
            editorRef.current.setContent("");
        }
        setSelectFile([]);
    };

    // Helper functions
    function formatBytes(bytes: any, decimals: number = 2) {
        if (!bytes || bytes === 0) return "0 Bytes";
        const k: number = 1024;
        const dm: number = decimals < 0 ? 0 : decimals;
        const sizes: string[] = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Form autoComplete="off" onSubmit={formik.handleSubmit} className={"container-fluid m-auto"}>
                        <Row>
                            <Col xxl={8}>
                                <Card>
                                    <Card.Header>
                                        <Card.Title as="h5" className="mb-3">News Information:</Card.Title>
                                        <hr/>
                                    </Card.Header>
                                    <Card.Body>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="title">Title <span
                                                className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                id="title"
                                                name="title"
                                                placeholder="title"
                                                value={formik.values.title}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.title}/>
                                            {formik.errors.title && formik.touched.title ? (
                                                <Form.Control.Feedback
                                                    type="invalid">{formik.errors.title}</Form.Control.Feedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Form.Label htmlFor="url">URL <span
                                                className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                id="url"
                                                name="url"
                                                placeholder="url"
                                                value={formik.values.url}
                                                onChange={(e) => {
                                                    let newValue = e.target.value
                                                        .replace(/['"@#$%&*\+/`~‘\s]/g, '')
                                                        .slice(0, 60);
                                                    formik.setFieldValue("url", newValue);

                                                }}
                                                onBlur={formik.handleBlur}
                                                onFocus={() => {
                                                    if (!formik.values.url) {
                                                        let res = formik.values.title.toLowerCase();
                                                        let res1 = res.replace(/['"@#$%&*-+/`~‘’]/g, '');
                                                        let res2 = res1.replace(/\s+/g, '-');
                                                        res2 = res2.substring(0, 60);
                                                        formik.setFieldValue("url", res2);
                                                    }
                                                }}
                                                isInvalid={!!formik.errors.url}
                                            />
                                            {formik.errors.url && formik.touched.url ? (
                                                <Form.Control.Feedback
                                                    type="invalid">{formik.errors.url}</Form.Control.Feedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Form.Label htmlFor="shortInfo">Short Description <span
                                                className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={4}
                                                id="shortInfo"
                                                name="shortInfo"
                                                placeholder="Short info..."
                                                value={formik.values.shortInfo}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.shortInfo}/>
                                            {formik.errors.shortInfo && formik.touched.shortInfo ? (
                                                <Form.Control.Feedback
                                                    type="invalid"> {formik.errors.shortInfo} </Form.Control.Feedback>
                                            ) : null}
                                        </div>

                                    </Card.Body>
                                </Card>

                                <Card>
                                    <Card.Body>
                                        <Card.Title className="mb-3">Content:</Card.Title>
                                        <Editor
                                            apiKey="e5n8ww55nxsiz86j2cu32zqr4ab587l4469ol6sadb34hvtm"
                                            onInit={handleEditorInit}
                                            initialValue="<p></p>"
                                            init={{
                                                height: 500,
                                                plugins: 'preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media codesample table wordcount help quickbars emoticons',
                                                imagetools_cors_hosts: 'picsum.photos',
                                                menubar: 'file edit view insert format tools table help',
                                                toolbar:
                                                    'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | source code | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | forecolor backcolor removeformat | fullscreen preview save | insertfile image media link anchor codesample | ltr rtl',
                                                content_style: 'body { font-family: Helvetica, Arial, sans-serif; font-size: 14px }',
                                            }}
                                        />

                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xxl={4}>
                                <Card>
                                    <Card.Header>
                                        <Card.Title className="mb-3">Details:</Card.Title>
                                        <hr/>
                                    </Card.Header>
                                    <Card.Body>
                                        <div className="mb-3">
                                            <Form.Label htmlFor="publishedAt">Date<span
                                                className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="datetime-local"
                                                id="publishedAt"
                                                name="publishedAt"
                                                placeholder="publishedAt"
                                                value={formik.values.publishedAt}
                                                onChange={(e) => {
                                                    const rawValue = e.target.value;
                                                    formik.setFieldValue("publishedAt", rawValue);
                                                }}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.publishedAt}/>
                                            {formik.errors.publishedAt && formik.touched.publishedAt ? (
                                                <Form.Control.Feedback
                                                    type="invalid">{formik.errors.publishedAt}</Form.Control.Feedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Form.Label
                                                htmlFor="newsStatusd">Status</Form.Label>
                                            <Form.Select
                                                id="newsStatusd"
                                                name="status"
                                                value={formik.values.status}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isInvalid={!!formik.errors.status}>
                                                <option value="true">Active</option>
                                                <option value="false">No active</option>
                                            </Form.Select>
                                            {formik.errors.status && formik.touched.status ? (
                                                <Form.Control.Feedback
                                                    type="invalid"> {formik.errors.status} </Form.Control.Feedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Dropzone
                                                onDrop={(acceptedFiles: File[]) => {
                                                    if (acceptedFiles.length > 0) {
                                                        const filesWithPreview = acceptedFiles.map(file => ({
                                                            ...file,
                                                            priView: URL.createObjectURL(file),
                                                            formattedSize: formatBytes(file.size),
                                                        }));

                                                        formik.setFieldValue("image", acceptedFiles[0]);
                                                        setSelectFile(filesWithPreview);
                                                    }
                                                }}
                                                multiple={false}
                                                accept={{"image/*": []}}
                                            >
                                                {(dropzoneProps: any) => {
                                                    const {getRootProps, getInputProps} = dropzoneProps;
                                                    return (
                                                        <div className="mb-3">
                                                            <Form.Label htmlFor="product-images-input">News
                                                                Image</Form.Label>
                                                            <div
                                                                {...getRootProps()}
                                                                className="dropzone my-dropzone border border-1 border-dashed text-center dz-clickable"
                                                                style={{minHeight: "100px"}}
                                                            >
                                                                <input {...getInputProps()} name="img"
                                                                       onBlur={formik.handleBlur}/>
                                                                <div className="dz-message needsclick py-3">
                                                                    <i className="bi bi-cloud-download fs-1 mb-2"/>
                                                                    <h5>Drop files here or click to upload.</h5>
                                                                </div>
                                                            </div>
                                                            {formik.errors.image && formik.touched.image && (
                                                                <Form.Control.Feedback
                                                                    type="invalid"
                                                                    className="d-block"
                                                                >
                                                                    {formik.errors.image}
                                                                </Form.Control.Feedback>
                                                            )}
                                                        </div>
                                                    );
                                                }}

                                            </Dropzone>

                                            <ul className="list-unstyled mb-0" id="dropzone-preview">

                                                {
                                                    (selectFile || [])?.map((file: any, index: number) => {
                                                        return (
                                                            <li className="mt-2 dz-image-preview" key={index}>
                                                                <div className="border rounded">
                                                                    <div className="d-flex flex-wrap gap-2 p-2">
                                                                        <div className="flex-shrink-0 me-3">
                                                                            <div
                                                                                className="avatar-sm bg-light rounded p-2">
                                                                                <img data-dz-thumbnail=""
                                                                                     className="img-fluid rounded d-block"
                                                                                     src={file?.priView}
                                                                                     alt={file?.name}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex-grow-1">
                                                                            <div className="pt-1">
                                                                                <h5 className="fs-md mb-1"
                                                                                    data-dz-name>{file?.path}</h5>
                                                                                <p className="fs-sm text-muted mb-0"
                                                                                   data-dz-size="">
                                                                                    <strong>{file.formattedSize}</strong>
                                                                                </p>
                                                                                <strong className="error text-danger"
                                                                                        data-dz-errormessage>
                                                                                </strong>
                                                                            </div>
                                                                        </div>
                                                                        <div className="flex-shrink-0 ms-3">
                                                                            <Button variant="danger" size="sm"
                                                                                    onClick={() => {
                                                                                        setSelectFile(null);
                                                                                    }}>Delete</Button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        );
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </Card.Body>
                                    <Card.Footer>
                                        <div className="hstack justify-content-between mb-3">
                                            <Button variant="danger" onClick={clearContent}>
                                                <i className="ph-x align-middle"></i> Cancel
                                            </Button>
                                            <Button type={"submit"} variant="primary">
                                                Create News
                                            </Button>
                                        </div>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </div>
            <ToastContainer/>
        </React.Fragment>
    )
}

export default CreateNews;